var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchiveViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 6.10714H3.375V13.8214C3.375 14.354 3.79473 14.7857 4.3125 14.7857H13.6875C14.2053 14.7857 14.625 14.354 14.625 13.8214V6.10714ZM2.4375 5.14286V13.8214C2.4375 14.8865 3.27697 15.75 4.3125 15.75H13.6875C14.723 15.75 15.5625 14.8865 15.5625 13.8214V5.14286H2.4375Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5625 3.21429H2.4375V5.14286H15.5625V3.21429ZM2.4375 2.25C1.91973 2.25 1.5 2.68173 1.5 3.21429V5.14286C1.5 5.67542 1.91973 6.10714 2.4375 6.10714H15.5625C16.0803 6.10714 16.5 5.67542 16.5 5.14286V3.21429C16.5 2.68173 16.0803 2.25 15.5625 2.25H2.4375Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8125 8.03571H6.1875V9H11.8125V8.03571ZM6.1875 7.07143C5.66973 7.07143 5.25 7.50315 5.25 8.03571V9C5.25 9.53256 5.66973 9.96429 6.1875 9.96429H11.8125C12.3303 9.96429 12.75 9.53256 12.75 9V8.03571C12.75 7.50315 12.3303 7.07143 11.8125 7.07143H6.1875Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveViewIcon);
export default __webpack_public_path__ + "static/media/archive-view-icon.9776e17be694f14152a12907dd5b095d.svg";
export { ForwardRef as ReactComponent };